//values

//ready
jQuery(document).ready(function () {

  //values
	let ua = window.navigator.userAgent;
	let ios = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
	let webkit = !!ua.match(/WebKit/i);
	let iossafari = ios && webkit && !ua.match(/CriOS/i);
	
	//if
	if(iossafari === true) {

		//add
		jQuery('body').addClass('software-iossafari');
		
	}
  
});

//functions
let serialize_form = function(form) {

  //values
	var obj = {};
	var formData = new FormData(form);

  //for
	for (var key of formData.keys()) {

    //set
		obj[key] = formData.get(key);
    
	}

  //return
	return obj;

}
